import { apiClient, getErrorMessage } from './client'

export { getErrorMessage }

export type AccessRequestStatus = 'pending' | 'approved' | 'denied'

export interface AccessRequestProfile {
  firstName?: string
  lastName?: string
  organization?: string
  jobTitle?: string
}

export interface AccessRequest {
  _id: string
  email: string
  profile: AccessRequestProfile
  requestedApps: string[]
  status: AccessRequestStatus
  createdAt: string
  updatedAt: string
}

export interface AccessRequestsListResponse {
  requests: AccessRequest[]
  total: number
  page: number
  pages: number
}

export interface ListAccessRequestsParams {
  status?: AccessRequestStatus
  page?: number
  limit?: number
}

export async function listAccessRequests(
  params: ListAccessRequestsParams = {}
): Promise<AccessRequestsListResponse> {
  const queryParams: Record<string, string> = {}

  if (params.status) {
    queryParams.status = params.status
  }
  if (params.page) {
    queryParams.page = params.page.toString()
  }
  if (params.limit) {
    queryParams.limit = params.limit.toString()
  }

  const response = await apiClient.get<AccessRequestsListResponse>('/admin/access-requests', {
    params: queryParams,
  })
  return response.data
}

export interface ApproveAppConfig {
  appId: string
  role: string
  scopes?: Record<string, unknown>
}

export interface ApproveAccessRequestParams {
  apps: ApproveAppConfig[]
  accessScopes?: Record<string, unknown>
}

export async function approveAccessRequest(
  id: string,
  params: ApproveAccessRequestParams
): Promise<{ message: string; userId: string }> {
  const response = await apiClient.post<{ message: string; userId: string }>(
    `/admin/access-requests/${id}/approve`,
    params
  )
  return response.data
}

export interface DenyAccessRequestParams {
  reason: string
}

export async function denyAccessRequest(
  id: string,
  params: DenyAccessRequestParams
): Promise<{ message: string }> {
  const response = await apiClient.post<{ message: string }>(
    `/admin/access-requests/${id}/deny`,
    params
  )
  return response.data
}
